import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';

export type EntityTab = {
	id: string;
	label: string;
	icon: string;
	accent?: string;
	count?: number | null;
	content?: TemplateRef<unknown>;
};

@Component({
	selector: 'of-entity-tabs',
	standalone: true,
	imports: [CommonModule],
	styleUrls: ['./entity-tabs.component.scss'],
	template: `
		<section class="entity-tabs">
			<div class="entity-tabs__list">
				<button
					*ngFor="let tab of tabs"
					type="button"
					class="entity-tabs__tab"
					[class.is-active]="activeTab === tab.id"
					[style.--tab-accent]="tab.accent"
					(click)="select(tab.id)"
				>
					<span class="entity-tabs__icon" aria-hidden="true">{{ tab.icon }}</span>
					<span>{{ tab.label }}</span>
					<span *ngIf="tab.count !== undefined && tab.count !== null" class="entity-tabs__count">({{ tab.count }})</span>
				</button>
			</div>

			<div class="entity-tabs__panel">
				<ng-container *ngFor="let tab of tabs">
					<ng-container *ngIf="tab.id === activeTab">
						<ng-container *ngIf="tab.content; else emptyTab">
							<ng-container *ngTemplateOutlet="tab.content"></ng-container>
						</ng-container>
					</ng-container>
				</ng-container>
				<ng-template #emptyTab>
					<p class="support-text">No tab content.</p>
				</ng-template>
			</div>
		</section>
	`,
})
export class EntityTabsComponent {
	@Input() tabs: EntityTab[] = [];
	@Input() activeTab: string | null = null;
	@Output() activeTabChange = new EventEmitter<string>();

	select(id: string) {
		this.activeTab = id;
		this.activeTabChange.emit(id);
	}
}
